let timeoutId;
const TIMEOUT_DURATION = 20000;

function showPreviousSaleBar(itemCount = 0, totalAmount = 0) {
    // Update the displayed item count and total amount
    $('#previousSaleItems').text(itemCount);
    $('#previousSaleTotal').html(totalAmount + ' <small>NOK</small>');

    $("#previousSaleBar").css({ bottom: '2.5px'});
    $('#previousSaleBar').addClass('show');

    // Clear any existing timers
    clearTimeout(timeoutId);

    // Auto-hide after 20 seconds
    timeoutId = setTimeout(function() {
        hidePreviousSaleBar();
    }, TIMEOUT_DURATION);
}

function hidePreviousSaleBar() {
    clearTimeout(timeoutId);

    timeoutId = null;
    $("#previousSaleBar").css({ bottom: '-150px'});
    $('#previousSaleBar').removeClass('show');
}